"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHoleStablefordPoints = calculateHoleStablefordPoints;
exports.isStablefordPlayType = isStablefordPlayType;
/**
 * Normalises a holePoints entry to a consistent { toPar, points } shape.
 * The tourBuilder stores entries with `scoreToPar`; PlayTypes.json defaults use `toPar`.
 * Both field names are supported here so data from either source works correctly.
 */
function normaliseEntry(entry) {
    return {
        toPar: entry.toPar ?? entry.scoreToPar,
        points: Number(entry.points),
    };
}
/**
 * Calculates Stableford points for a single hole.
 *
 * @param playerScore - Raw strokes recorded for the hole (0 = unplayed)
 * @param par         - Par value for the hole
 * @param hcpAdj      - Handicap stroke adjustment for the hole
 * @param isNet       - When true, subtract hcpAdj before computing toPar
 * @param holePoints  - toPar/scoreToPar → points mapping from tbRound.holePoints
 * @returns Points for the hole, or 0 if unplayed / no mapping defined
 */
function calculateHoleStablefordPoints(playerScore, par, hcpAdj, isNet, holePoints) {
    if (!playerScore || playerScore === 0)
        return 0;
    if (!holePoints || holePoints.length === 0)
        return 0;
    const netScore = playerScore - (isNet ? hcpAdj : 0);
    const toPar = netScore - par;
    const normalised = holePoints.map(normaliseEntry);
    const match = normalised.find(hp => hp.toPar === toPar);
    if (match !== undefined)
        return match.points;
    // Score is outside the defined mapping — clamp to the boundary values.
    const sorted = [...normalised].sort((a, b) => a.toPar - b.toPar);
    if (toPar < sorted[0].toPar) {
        // Better than the best mapped score (e.g. condor) — use max points
        return sorted[0].points;
    }
    // Worse than the worst mapped score — use min points
    return sorted[sorted.length - 1].points;
}
/**
 * Returns true if the given play type string represents Stableford.
 */
function isStablefordPlayType(playType) {
    return playType?.toLowerCase() === 'stableford';
}
